import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";

import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import LocDevices from "../components/editviews/location/LocDevices";
import LocUsers from "../components/editviews/location/LocUsers";
import LocationSettings from "../components/editviews/location/LocationSettings";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";
function LocDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location?.state;
  const [locDetailsInfo, setLocDetailsInfo] = useState(
  stateData?.currentLoc ?? stateData?.info ?? stateData ?? {}
);
const [nextLoc, setnextLoc] = useState(stateData?.nextLoc ?? null);
const [prevLoc, setprevLoc] = useState(stateData?.previousLoc ?? null);
const [locList, setlocList] = useState(stateData?.locationList ?? []);
  const tabid = location.state && location.state.tab ? location.state.tab + "" : "tab1";
  const [basicActive, setBasicActive] = useState(tabid);
  const [basicActive1, setBasicActive1] = useState("tab4");

  const [basicModal1, setBasicModal1] = useState(false);
  const toggleShow1 = () => setBasicModal1(!basicModal1);
  const [selectVal, setSelectVal] = useState("africa");
  const [verticalActive, setVerticalActive] = useState("tab1");
  const [selectedRowsAdvanced, setSelectedRowsAdvanced] = useState([]);
  const [modalState, setModalState] = useState({ from: "", message: "" });
  const [locName, setlocName] = useState("");
  const [locAddress, setlocAddress] = useState("");
  const locDevices = useRef(null);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);


  const [reqFromCallFlow, setreqFromCallFlow] = useState(false);

  function setDeviceList(data) {
    locDevices.current = data;
  }
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    // reset();
    if (targetView.indexOf("/") !== -1) {
      const targetValues = targetView.split("#")
      if (targetValues.length > 2) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1], tab1: targetValues[2] },
          }
        );

      } else if (targetValues.length > 1) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1] },
          }
        );


      } else {
        navigate(targetValues[0]);
      }
    } else {
      setBasicActive(targetView);
    }
    setShowWarning(false);
  };

  useEffect(() => {
    const locDetails = localStorage.getItem("locScheduleInfo");
    if (locDetails) {
      setreqFromCallFlow(true);
      setLocDetailsInfo({ location_id: parseInt(locDetails) });
      console.log("locScheduleInfo::", locDetails)
      localStorage.removeItem("locScheduleInfo");

    }

  }, [])

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const modifytheState = (e, locObj) => {
    e.preventDefault();
    
    const currentIndex = locList.findIndex((tmdata) => tmdata.location_id == locObj.location_id);
    const previousLoc = currentIndex > 0 ? locList[currentIndex - 1] : null;
    const nextLoc = currentIndex < locList.length - 1 ? locList[currentIndex + 1] : null;
    
    const combinedData = {
      currentLoc: locObj,
      previousLoc,
      nextLoc,
      locationList: locList
    };
    // Navigate based on 911 flag
    if (locObj.is_911 || locObj.nineoo_loc_id) {
      navigate("/location911settings", {
        state: combinedData,
      });
    } else {
      // Update state if staying on same page
      setLocDetailsInfo(locObj);
      setprevLoc(previousLoc);
      setnextLoc(nextLoc);
    }
  };

  return (
    <>
      <form>
        <MainLinks active={7} />
        <Body
          tablinks={7}
          sublink={7}
          content={
            <>
              <section>
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a onClick={(e) => {
                            if (isEdited) {
                              if (locDetailsInfo.is_911 !== undefined) {
                                setTargetView("/loclanding#location#tab1");

                              } else {
                                setTargetView("/LocLanding#location#tab2");
                              }
                              setShowWarning(true);
                              return;
                            }
                            // navigate("/loclanding");
                            if (locDetailsInfo.is_911 !== undefined) {
                              navigate("/LocLanding", {
                                state: { tab: "location", tab1: "tab1" },
                              });

                            } else {
                              navigate("/LocLanding", {
                                state: { tab: "location", tab1: "tab2" },
                              });
                            }
                          }}>
                            <strong>{t("locations")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a onClick={(e) => {
                            if (isEdited) {
                              if (locDetailsInfo.is_911 !== undefined) {
                                setTargetView("/loclanding#location#tab1");

                              } else {
                                setTargetView("/LocLanding#location#tab2");

                              }
                              setShowWarning(true);
                              return;
                            }
                            // navigate("/loclanding");
                            if (locDetailsInfo.is_911 !== undefined) {
                              navigate("/LocLanding", {
                                state: { tab: "location", tab1: "tab1" },
                              });

                            } else {
                              navigate("/LocLanding", {
                                state: { tab: "location", tab1: "tab2" },
                              });
                            }
                          }}>
                            <strong>{t("locations")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="#">
                            <strong>{locName}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                                            <div className="headerbtns">
                                              <div className="customtooltip">
                                                <MDBBtn
                                                  size="sm"
                                                  color="transparent"
                                                  className={prevLoc != null ? "ms-2 " : "ms-2"}
                                                  disabled={prevLoc == null || prevLoc === ""}
                                                  onClick={(e) => modifytheState(e, prevLoc)}
                                                >
                                                  <i className="fa fa-chevron-left"></i>
                                                </MDBBtn>
                                                {prevLoc != null && prevLoc !== "" && (
                                                  <span className="tooltiptext">
                                                    Previous:
                                                    <br />
                                                    {prevLoc != null
                                                      ? prevLoc.location_name
                                                      : ""}
                                                  </span>
                                                )}
                                              </div>
                                              <div className="customtooltip">
                                                <MDBBtn
                                                  size="sm"
                                                  color="transparent"
                                                  className={
                                                    nextLoc != null
                                                      ? "ms-2 active"
                                                      : "ms-2 active"
                                                  }
                                                  disabled={
                                                    nextLoc == null || nextLoc === ""
                                                  }
                                                  onClick={(e) =>
                                                    modifytheState(e, nextLoc)
                                                  }
                                                >
                                                  <i className="fa fa-chevron-right"></i>
                                                </MDBBtn>
                                                {nextLoc != null && nextLoc !== "" && (
                                                  <span className="tooltiptext">
                                                    Next:
                                                    <br />
                                                    {nextLoc != null
                                                      ? nextLoc.location_name
                                                      : ""}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                          
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <div className="w-100 mb-3">
                      <h5 className="fw-600 mt-2 mb-0">
                        {locName}
                        <p className="mt-1  text-secondary">
                          {locAddress}
                        </p>
                      </h5>
                    </div>

                    <MDBTabs>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          {t("users")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab3")}
                            active={basicActive === "tab3"}
                          >
                            {t("devices")}
                          </MDBTabsLink>
                        </>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        {/* Tab 1 content */}
                        <LocationSettings
                          locDetailsInfo={locDetailsInfo}
                          setLocDevicesList={setDeviceList}
                          setlocName={setlocName}
                          setlocAddress={setlocAddress}
                          isActive={basicActive === "tab1"}
                          setreqFromCallFlow={setreqFromCallFlow}
                          reqFromCallFlow={reqFromCallFlow}
                        />
                      </MDBTabsPane>

                      <MDBTabsPane
                        open={basicActive === "tab2"}
                        className="p-0"
                      >
                        <LocUsers
                          locid={locDetailsInfo.location_id}
                          locDetailsInfo={locDetailsInfo}
                        />
                      </MDBTabsPane>
                      {/* {enableNineOneOneLoc.current && ( */}
                      <>
                        <MDBTabsPane open={basicActive === "tab3"}>
                          <LocDevices
                            locDevicesList={locDevices.current}
                            isActive={basicActive === "tab3"}
                          />
                        </MDBTabsPane>
                      </>
                      {/* )} */}
                    </MDBTabsContent>
                  </div>
                </div>
              </section>
              <MDBModal
                open={basicModal1}
                setShow={setBasicModal1}
                tabIndex="-1"
              >
                <MDBModalDialog>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>{t("add_New_User")}</MDBModalTitle>
                      <MDBBtn
                        className="btn-close"
                        color="none"
                        onClick={toggleShow1}
                      ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className="row">
                        <div className="tel-numbers pt-2">
                          <strong>{t("removeHuntGroup")}</strong>
                        </div>
                      </div>
                    </MDBModalBody>

                    <MDBModalFooter>
                      <MDBBtn color="secondary" onClick={toggleShow1}>
                        {t("close")}
                      </MDBBtn>
                      <MDBBtn>{t("addUser")}</MDBBtn>
                    </MDBModalFooter>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>

          }
        />
        {/* <Footer /> */}
      </form >
      {showWarning && (
        <EditWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={handleOk}
        />
      )}
    </>
  );



}

export default LocDetails;
